// #region imports

// --- Angular
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

// --- 3rd Party
import { User as OidcUser } from 'oidc-client';
import moment from 'moment';

// --- HS Code
import { LIB_VERSION as version } from '../../../../version';
import { SurveyStatuses, SurveySummaryModel } from '../../../models';

// #endregion

@Component({
  selector: 'hs-dashboard-side-nav',
  templateUrl: './dashboard-side-nav.component.html',
  styleUrls: ['./dashboard-side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardSideNavComponent implements OnChanges {

  @Input() isParticipant: boolean = false;
  @Input() isOpen: boolean | null = false;
  @Input() isRespondent: boolean = false;
  @Input() showRegisterButton = true;
  @Input() user: OidcUser | null = null;
  @Input() selfSurveys: SurveySummaryModel[] | null = null;

  @Output() closeNavigation = new EventEmitter();
  @Output() logout = new EventEmitter();
  @Output() registerClicked = new EventEmitter<{}>();
  @Output() getStarted = new EventEmitter();

  hasIncompleteSurveys: boolean = false;
  firstIncompleteSurveyMoniker: string | null = null;
  appVersion: string = version;

  ngOnChanges(changes: SimpleChanges): void {
      if (changes && changes['selfSurveys'] && changes['selfSurveys'].currentValue) {
        const incompleteSurveys = this.selfSurveys?.filter(ss => ss.status < SurveyStatuses.completeSurvey && moment(ss.lockDate).isAfter(moment()));
        const incompleteSurveyCount = this.selfSurveys?.filter(ss => ss.status < SurveyStatuses.completeSurvey && moment(ss.lockDate).isAfter(moment()))?.length ?? 0;
        this.hasIncompleteSurveys = incompleteSurveyCount > 0;
        if (incompleteSurveys && incompleteSurveyCount > 0) {
          this.firstIncompleteSurveyMoniker = incompleteSurveys[0].moniker;
        }
      }
  }

  closeNavigationClick() {
    this.closeNavigation.emit();
  }

  logoutClick() {
    this.logout.emit();
  }

  registerButtonClicked() {
    this.registerClicked.emit({
      hasIncompleteSurveys: this.hasIncompleteSurveys,
      surveyReference: this.firstIncompleteSurveyMoniker
    });
  }
}
